import React, { useEffect, useState } from "react";
import {
  Col,
  Row,
  Card,
  CardHeader,
  CardBody,
  Form,
  FormGroup,
  Label,
  InputGroup,
  InputGroupText,
} from "reactstrap";
import FootprintDatePicker from "../../../../Components/utils/FootprintDatePicker";
import moment from "moment";

import { useRequestProcessor } from "../../../../requestProcessor";
import { useAtom } from "jotai";
import { activeChildDetail, mobileAtom } from "../../../../AtomStore/store";

import SpinnerLoading from "../../../../Components/utils/SpinnerLoading";
import { handleGetFeeCertificate } from "../../../../QueryFunctions/queryfunction";
import { useNavigate } from "react-router-dom";
import { StyledGenerateButton } from "../styles";

const FeeCertificate = () => {
  const { useMutationWrapper } = useRequestProcessor();

  const navigate = useNavigate();
  const [state, setState] = useState();
  const [activeChild] = useAtom(activeChildDetail);

  useEffect(() => {
    console.log(
      "[Fee Certificate] Initializing Get Fee Ceritificate form for child:",
      activeChild?.id
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getFeeCertificate = useMutationWrapper(
    "getFeeCertificate",
    () => {
      console.log(
        "[Fee Certificate] Calling API:/financials/getTuitionFeeCertificate",
        state
      );
      return handleGetFeeCertificate(state, navigate);
    },
    {
      onSuccess: (data) => {
        console.log("[Fee Certificate] Get Fee Certificate response:", data);
      },
    }
  );

  const validate = () => {
    if (state?.startDate === undefined) {
      setState({ ...state, error: "Please Select From Date" });
      return false;
    } else if (state?.endDate === undefined) {
      setState({ ...state, error: "Please Select End Date" });
      return false;
    } else {
      return true;
    }
  };

  const submit = () => {
    if (validate()) {
      getFeeCertificate.mutate();
    } else {
    }
  };
  return (
    <div className="m-[10px] mt-[20px]">
      {getFeeCertificate.isLoading && <SpinnerLoading />}

      <div className="bg-white rounded shadow p-2 ">
        <div className="pt-1 md:p-2 pb-2">
          <form className="space-y-4">
            <div className="grid grid-cols-2">
              {/* From Date */}
              <div className="border-r">
                <label
                  htmlFor="startDate"
                  className="block text-sm font-medium text-black mb-1"
                >
                  From
                </label>
                <div className="flex items-center">
                  <FootprintDatePicker
                    onChange={(date) =>
                      setState({
                        ...state,
                        holidaySelected: false,
                        startDate: moment(date),
                        error: undefined,
                      })
                    }
                    inputProps={{
                      placeholder: "Start Date",
                    }}
                    timeFormat={false}
                  />
                  {/* <i className="icon-calender text-black text-2xl" /> */}
                </div>
              </div>

              {/* To Date */}
              <div>
                <label
                  htmlFor="endDate"
                  className="block text-sm font-medium text-black text-right mb-1"
                >
                  To
                </label>
                <div className="flex items-center right-align">
                  {/* <i className="icon-calender text-2xl text-black mr-2" /> */}

                  <FootprintDatePicker
                    onChange={(date) =>
                      setState({
                        ...state,
                        endDate: moment(date),
                        holidaySelected: false,
                        error: undefined,
                      })
                    }
                    inputProps={{
                      placeholder: "End Date",
                      textAlign: "right",
                    }}
                    timeFormat={false}
                  />
                </div>
              </div>
            </div>
            {/* <hr className=" mx-2 bg-black md:hidden" /> */}

            {/* Error Message */}
            {typeof state?.error !== "undefined" && (
              <p className="text-red-600 text-sm font-medium">{state?.error}</p>
            )}

            {/* Submit Button */}
            <div className="text-center">
              <StyledGenerateButton onClick={() => submit()}>
                Generate
              </StyledGenerateButton>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default FeeCertificate;
